import { GET_POST_PROPERTY_QUERY, RAW_UNIT_QUERY, RAW_UNITS_QUERY } from "@/gql/sup";
import { RawUnit } from "@/types/rawUnit";
import { getApolloData } from "@/utils/apollo/get-data";
import { getFormDataFromSaveable } from "@/utils/get-saveable-documents-info";
import { removeTypename } from "@/utils/removeTypeName";

export async function fetchRawUnit({ groupId, id }: { groupId: string; id: string }) {
	const variables = {
		params: {
			one: { groupId, id },
		},
	};
	const { data, error } = await getApolloData<{ rawUnits?: { one?: any } }>({ query: RAW_UNIT_QUERY, variables });
	if (error) throw error;
	return data?.rawUnits?.one;
}

export async function fetchPostProperty({
	id,
	groupId,
	isAuthenticated,
}: {
	id: string;
	groupId: string;
	isAuthenticated: boolean;
}) {
	const variables = {
		params: {
			getPostProperty: { id, groupId },
		},
	};
	const { data, error } = await getApolloData<{ rawUnits?: { getPostProperty?: any } }>({
		query: GET_POST_PROPERTY_QUERY,
		variables,
		skip: !isAuthenticated || Boolean(!id) || Boolean(!groupId),
	});
	if (error) throw error;
	if (!data?.rawUnits?.getPostProperty) return null;

	const cleanedRawUnit = removeTypename(data?.rawUnits?.getPostProperty);
	if (!cleanedRawUnit) return null;

	if (!Array.isArray(cleanedRawUnit)) {
		cleanedRawUnit.images = cleanedRawUnit.images?.length ? cleanedRawUnit.images : null;
		if (cleanedRawUnit?.documents?.length) {
			cleanedRawUnit.documents = getFormDataFromSaveable(cleanedRawUnit?.documents);
		}
		return cleanedRawUnit;
	}
	return null;
}

export async function fetchRawUnits({ groupId }: { groupId: string }): Promise<RawUnit[]> {
	const variables = {
		params: {
			list: {
				groupId,
				unProcessedOnly: true,
			},
		},
	};
	const { data, error } = await getApolloData<{ rawUnits?: { list?: RawUnit[] } }>({
		query: RAW_UNITS_QUERY,
		variables,
		skip: !groupId,
	});
	if (error) throw error;
	return data?.rawUnits?.list?.map(r => removeTypename(r)).filter((r): r is RawUnit => !!r && !Array.isArray(r)) || [];
}
